<template>
  <div v-if="rows" class="as-incident-list">
    <div v-if="datas" class="as-incident-list__head">
      <div class="as-player">
        <img
          :src="getImgUrlBySport('player', datas[0]?.home_player_id || 'default')"
          class="as-player__logo"
          alt="Unknown Player Name"
        />
        <div class="as-player__detail">
          <div class="as-player__point">
            <span class="as-num">{{ datas[0]?.home }}</span
            ><span class="as-txt">PTS</span>
          </div>
          <div class="as-player__name">
            {{ datas[0]?.home_player_name }}
          </div>
        </div>
      </div>
      <div class="as-head-content">Kiếm nhiều điểm nhất</div>
      <div class="as-player as-player__away">
        <img
          :src="getImgUrlBySport('player', datas[0]?.away_player_id || 'default')"
          class="as-player__logo"
          alt="Unknow"
        />
        <div class="as-player__detail">
          <div class="as-player__point">
            <span class="as-num">{{ datas[0]?.away }}</span
            ><span class="as-txt">PTS</span>
          </div>
          <div class="as-player__name">
            {{ datas[0]?.away_player_name }}
          </div>
        </div>
      </div>
    </div>

    <div class="as-incident-list__list">
      <div
        v-for="(row, index) in rows"
        :key="index"
        class="as-incident-list__item"
      >
        <h3
          @click="changeActiveCollapse(index)"
          :class="{
            'as-active': activeCollapse === index,
          }"
        >
          <span>
            {{ collapses.find((collapse) => collapse.value == index)?.title }}
          </span>
          <ArrowDown fill="#4CF446" />
        </h3>
        <div v-for="data in row.data" v-show="activeCollapse === index">
          <div v-if="data.teamGoal === 2" class="as-incident-list__row">
            <div class="as-left"></div>
            <div class="as-time">{{ convertTime(data.remaining_time) }}</div>
            <div class="as-right">
              <IncidentPlayer
                :player="data"
                :playerName="
                  mapPlayer(data[1], props?.detailShooting?.listPlayer)?.name ||
                  ''
                "
                :point="data.point"
                type="away"
                :pointHomeMatch="props?.detailShooting?.match.away_scores"
                :pointAwayMatch="props?.detailShooting?.match.home_scores"
                :indexCurrentScore="row.indexCurrentScore"
              />
            </div>
          </div>
          <div v-else class="as-incident-list__row">
            <div class="as-left">
              <IncidentPlayer
                :player="data"
                :playerName="
                  mapPlayer(data[1], props?.detailShooting?.listPlayer)?.name ||
                  ''
                "
                :point="data.point"
                type="home"
                :pointHomeMatch="props?.detailShooting?.match.away_scores"
                :pointAwayMatch="props?.detailShooting?.match.home_scores"
                :indexCurrentScore="row.indexCurrentScore"
              />
            </div>
            <div class="as-time">{{ convertTime(data.remaining_time) }}</div>
            <div class="as-right"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <NoData v-else />
</template>

<script setup lang="ts">
import { defineProps, ref, computed } from "vue";
import { mapPlayer } from "~src/helpers/basketball";
import ArrowDown from "~src/components/icons/ArrowDown.vue";
import type { IMatch } from "~src/interfaces/basketball";
import IncidentPlayer from "~src/components/incidents/basketball/IncidentPlayer.vue";
import NoData from "~src/components/NoData.vue";

interface IProps {
  isPopup: boolean;
  detailShooting: {
    shootingPoints: IRow;
    match: IMatch;
  };
}

interface IRow {
  data: {
    teamGoal: number;
    remaining_time: number;
    point: number;
    [key: string]: any;
  }[];
  match_status: number;
}

const props = withDefaults(defineProps<IProps>(), {
  isPopup: true,
});

const rows: any = computed(() => {
  const rs = props?.detailShooting?.shootingPoints;
  if (!rs) return [];
  const { home_scores, away_scores } = props?.detailShooting?.match;
  const data: any[] = [];
  rs.map((item: any) => {
    const t = item.data.filter((i: any) => {
      return i.homeScore > 0 || i.awayScore > 0;
    });

    if (item.match_status !== 10) {
      let indexCurrentScore = 0;
      if (item.match_status === 8) {
        indexCurrentScore = 3;
      } else if (item.match_status === 6) {
        indexCurrentScore = 2;
      } else if (item.match_status === 4) {
        indexCurrentScore = 1;
      } else if (item.match_status === 2) {
        indexCurrentScore = -1;
      }
      data.push({
        data: t,
        match_status: item.match_status,
        indexCurrentScore,
      });
    }
  });

  return data;
});
const calculateTotalScore = (scores: number[], index: number) => {
  let total = 0;
  for (let i = 0; i <= index; i++) {
    total += scores[i];
  }
  return total;
};
const collapses = computed(() => {
  if (!props?.detailShooting?.shootingPoints) return [];
  const data: any[] = [];
  let jsonData = props?.detailShooting?.shootingPoints;
  const includeStatusEnd = jsonData.find(
    (item: any) => item.match_status === 10
  );
  jsonData = jsonData.filter((item: any) => item.match_status != 10);

  jsonData.map((item: any, index: any) => {
    let title = "";
    let value = 0;
    const { home_scores, away_scores } = props?.detailShooting?.match;
    if (item.match_status === 8 && !includeStatusEnd) {
      title = `H4 ${calculateTotalScore(
        home_scores,
        3
      )} - ${calculateTotalScore(away_scores, 3)}`;
      if (item?.data.length === 1) {
        title = `H4 0 - 0`;
      }
      value = index;
    } else if (item.match_status === 8 && includeStatusEnd) {
      title = `FT ${calculateTotalScore(
        home_scores,
        4
      )} - ${calculateTotalScore(away_scores, 4)}`;
      if (item?.data.length === 1) {
        title = `H4 0 - 0`;
      }
      value = 0;
    } else if (item.match_status === 9 && includeStatusEnd) {
      title = `FT ${calculateTotalScore(
        home_scores,
        4
      )} - ${calculateTotalScore(away_scores, 4)}`;
      if (item?.data.length === 1) {
        title = `OT 0 - 0`;
      }
      value = 0;
    } else if (item.match_status === 9 && !includeStatusEnd) {
      title = `OT ${calculateTotalScore(
        home_scores,
        4
      )} - ${calculateTotalScore(away_scores, 4)}`;
      if (item?.data.length === 1) {
        title = `OT 0 - 0`;
      }
      value = 0;
    } else if (item.match_status === 6) {
      title = `H3 ${calculateTotalScore(
        home_scores,
        2
      )} - ${calculateTotalScore(away_scores, 2)}`;
      if (item?.data.length === 1) {
        title = `H3 0 - 0`;
      }
      value = index;
    } else if (item.match_status === 4) {
      title = `H2 ${calculateTotalScore(
        home_scores,
        1
      )} - ${calculateTotalScore(away_scores, 1)}`;
      if (item?.data.length === 1) {
        title = `H2 0 - 0`;
      }
      value = index;
    } else if (item.match_status === 2) {
      title = `H1 ${calculateTotalScore(
        home_scores,
        0
      )} - ${calculateTotalScore(away_scores, 0)}`;
      if (item?.data.length === 1) {
        title = `H1 0 - 0`;
      }
      value = index;
    }
    // value = index;
    if (title) {
      data.push({
        title,
        value,
      });
    }
  });
  return data;
});

let activeCollapse: any = ref(collapses?.value[0]?.value) || 0;

const changeActiveCollapse = (index: any) => {
  if (activeCollapse.value === index) {
    activeCollapse.value = "";
  } else {
    activeCollapse.value = index;
  }
};

const convertTime = (time: number) => {
  const minutes = Math.floor(time / 60);
  const seconds = time % 60;
  return `${minutes}:${seconds}`;
};

const getParcent = (homeVal: number, awayVal: number) => {
  const total: number = homeVal + awayVal;

  const rsHome = ((homeVal / total) * 100).toFixed();
  const rsAway = ((awayVal / total) * 100).toFixed();

  return {
    home: rsHome,
    away: rsAway,
  };
};

interface IData {
  title: string;
  home: number;
  away: number;
  home_player_id: string | null;
  home_player_name: string | null;
  away_player_id: string | null;
  away_player_name: string | null;
}

const datas = computed(() => {
  const items: IData[] = [
    {
      title: "Điểm",
      home: 0,
      away: 0,
      home_player_id: null,
      home_player_name: null,
      away_player_id: null,
      away_player_name: null,
    },
  ];

  if (props?.detailShooting?.lineups?.players) {
    for (const player of props?.detailShooting?.lineups.players.home) {
      if (player.data.score > items[0].home) {
        items[0].home = player.data.score;
        items[0].home_player_id = player.id;
        items[0].home_player_name = player.name;
      }
    }
    for (const player of props?.detailShooting?.lineups.players.away) {
      if (player.data.score > items[0].away) {
        items[0].away = player.data.score;
        items[0].away_player_id = player.id;
        items[0].away_player_name = player.name;
      }
    }
  }

  return items;
});
</script>

<script lang="ts">
export default {};
</script>
